import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel(); }}>
      <AlertDialogContent className="border border-border/80 bg-card/90 backdrop-blur-xl shadow-2xl p-6 rounded-lg max-w-sm">
        <AlertDialogHeader className="flex flex-col items-center text-center">
          <div className="p-3 rounded-full bg-red-500/10 text-red-400 mb-4 animate-pulse">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <AlertDialogTitle className="font-serif-display text-lg text-foreground font-bold">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-xs text-muted-foreground mt-2 leading-relaxed">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-row gap-2 mt-6 w-full">
          <AlertDialogCancel
            onClick={onCancel}
            className="flex-1 bg-void hover:bg-card border border-border text-muted-foreground hover:text-foreground text-[10px] font-mono-tech uppercase py-2 cursor-pointer transition-all animate-in fade-in"
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="flex-1 bg-red-600 hover:bg-red-500 text-white text-[10px] font-mono-tech uppercase py-2 cursor-pointer transition-all hover:scale-105 active:scale-95 shadow-[0_0_10px_rgba(239,68,68,0.2)] animate-in fade-in"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
